import React, { useState, useEffect, useRef } from 'react';
import HomepageHeader from '../components/homepageHeader';
import Footer from '../components/footer';
import LOGO_IMG from '../assets/homepage/logo.png';
import ICON from '../assets/homepage/icon.png';
import './homepage.scss';
import { ArrowRightOutlined } from '@ant-design/icons';
import LOGO_IMG_WHITE from '../assets/homepage/logo_white.png';
import DEFAULT_IMG from '../assets/default.png';
import { EllipsisOutlined } from '@ant-design/icons';

import { useHistory, useLocation, useParams } from 'react-router-dom';

import QQ from '../assets/homepage/qq.png';
import PHONE from '../assets/homepage/phone.png';
import WECHAT from '../assets/homepage/wechat.png';

import {
  listRecommendProductsInfo,
  listRecommendAcyivityInfo,
  listRecommentNews,
  listHomepageType,
} from '../api/homepage';

import ACTIVITY_IMG from '../assets/homepage/activity.png';
import ACTIVITY_TITRLE_IMG from '../assets/homepage/activity_title.png';
import ABOUT_IMG from '../assets/homepage/about.png';
import { AxiosResponse } from 'axios';

interface IRecommandProductsInfo {
  backgroundPicUrl: string;
  topicPicUrl: string;
  id: string;
}

interface IRecommendNewsInfo {
  id: number;
  publishDate: string;
  status: number;
  title: string;
  type: 1 | 2 | 3;
}

interface IProductTypeInfo {
  catalogDes: string;
  catalogName: string;
  catalogNameEn: string;
  level: number;
  picUrl: string;
  picUrlHover: string;
  id: string;
}

const map = Object.freeze({
  a: {
    en: 'Product Details',
    'zh-cn': '查看产品详情',
  },
  b: {
    en: 'Shandong Fantai Fine Chemical Biotechnology Co., Ltd.',
    'zh-cn': '山东钒泰精化生物科技有限公司',
  },
  c: {
    en: `Shandong Fantai Fine Chemical Biotechnology Co., Ltd. is located in Weifang, the world's kite capital, the transportation hub of Shandong Province, with superior geographical location and convenient transportation.`,
    'zh-cn': '山东钒泰精化生物科技有限公司位于山东省交通枢纽世界风筝之都潍坊，地理位置优越、交通便利',
  },
  d: {
    en: `The team has had many years of custom synthesis cooperation with domestic and foreign drug research and development related companies and units, with the purpose of building the company into a fine chemical enterprise engaged in the research and development, production and sales of fine chemicals, pharmaceutical intermediates and raw materials. The company is now striving to build a one-stop procurement platform from basic reagents to high-end chemicals to realize a green chemical platform. Based on the concept of mutual benefit and win-win cooperation, we are willing to sincerely cooperate with new and old customers to create brilliance and jointly promote the development of the industry. Contribute to our living environment.`,
    'zh-cn':
      '钒泰团队有多年与国内外药物研发相关企业及单位定制合成的合作，目的是将公司建设成一家从事精细化学品、医药中间体和原料的研发、生产和销售的精细化工企业。公司现着力打造从基础试剂到高端化学品的一站式采购平台，实现绿色化工平台。本着互惠互利、合作共赢的理念，愿与新老客户精诚合作、共创辉煌，共同促进行业的发展。为我们的生存环境贡献一份力量。',
  },
  e: {
    en: 'MORE',
    'zh-cn': '查看更多',
  },
});

const HomePage = () => {
  const type = Object.freeze({
    1: {
      en: 'HOT',
      'zh-cn': '热门活动',
    },
    2: {
      en: 'NEWS',
      'zh-cn': '公司动态',
    },
    3: {
      en: 'FOCUS',
      'zh-cn': '行业焦点',
    },
  });

  const color = Object.freeze({
    1: 'red',
    2: 'brown',
    3: 'blue',
  });

  const history = useHistory();
  const location = useLocation();

  const [recommandProductsInfo, setRecommendProductsInfo] = useState({
    backgroundPicUrl: '',
    topicPicUrl: '',
    id: '',
  });

  const [recommendNewsInfo, setRecommendNewsInfo] = useState([]);

  const [la, setLa] = useState<'en' | 'zh-cn'>('zh-cn');

  const [recommendActivityInfo, setRecommendActivityInfo] = useState({
    backgroundPicUrl: '',
    topicPicUrl: '',
    id: '',
  });

  const [productList, setProductList] = useState([]);
  const [divHoverStatus, setDivHoverStatus] = useState<{ [key: number]: boolean }>({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
  });

  const toAbout = () => history.push('/' + la + '/about');
  const toNews = () => history.push('/' + la + '/news');

  const toProducts = (type?: string) => {
    if (type) history.push('/' + la + `/product?type=${type}`);
    else history.push('/' + la + `/product`);
  };
  const toNewsDetail = (id: number) => history.push('/' + la + `/news/${id}`);

  const handleHover = (index: number) => {
    setDivHoverStatus({
      ...divHoverStatus,
      [index]: true,
    });
  };

  const handleLeave = (index: number) => {
    setDivHoverStatus({
      ...divHoverStatus,
      [index]: false,
    });
  };

  useEffect(() => {
    const getRecommendProductsInfo = () => {
      listRecommendProductsInfo().then((res: AxiosResponse<IRecommandProductsInfo>) => {
        const data = res.data;
        setRecommendProductsInfo({
          topicPicUrl: data.topicPicUrl,
          backgroundPicUrl: data.backgroundPicUrl,
          id: data.id,
        });
      });
    };

    const getRecommendActivityInfo = () => {
      listRecommendAcyivityInfo().then((res: AxiosResponse<IRecommandProductsInfo>) => {
        const data = res.data;
        setRecommendActivityInfo({
          topicPicUrl: data.topicPicUrl,
          backgroundPicUrl: data.backgroundPicUrl,
          id: data.id,
        });
      });
    };

    const getRecommendNewsInfo = () => {
      listRecommentNews({
        page: 1,
        limit: 5,
      }).then((res) => {
        setRecommendNewsInfo(res.data || []);
      });
    };

    const getHomepageType = () => {
      listHomepageType().then((res) => {
        if (res.status === 200) {
          let data = res.data;
          if (Array.isArray(data) && data.length > 12) {
            data = data.slice(0, 12);
          }
          setProductList(data || []);
        }
      });
    };

    getRecommendProductsInfo();
    getRecommendActivityInfo();
    getRecommendNewsInfo();
    getHomepageType();
  }, []);

  const { lang } = useParams();
  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  const goProductDetail = () => {
    if (recommandProductsInfo.id) history.push('/' + la + '/product/' + recommandProductsInfo.id);
    else history.push('/' + la + '/product');
  };

  return (
    <div className='homepage'>
      <HomepageHeader {...recommendActivityInfo} />
      {/* 产品系列 */}
      <div className='product-line'>
        <div className='split-title-content'>
          <p className='title'>产品系列</p>
          <div className='split-line'>
            <div className='line'></div>
            <div className='logo'>
              <img src={LOGO_IMG} alt='' />
            </div>
            <div className='line'></div>
          </div>
          <p className='sub-title'>Product Line</p>
        </div>

        <div className='product-line-content'>
          {productList.slice(0, 7).map((product: IProductTypeInfo, index: number) => (
            <div
              className='product-box'
              key={product.id}
              onMouseOver={() => handleHover(index)}
              onMouseOut={() => handleLeave(index)}
              onClick={() => toProducts(product.id)}
            >
              <div
                className='icon'
                style={{ background: `url(${divHoverStatus[index] ? product.picUrlHover : product.picUrl})` }}
              >
                {/* <img src={product.picUrl || DEFAULT_IMG} alt='' /> */}
              </div>
              <div className='title'>{product.catalogName}</div>
              <div className='sub-title'>{product.catalogNameEn}</div>
            </div>
          ))}
          <div
            className='product-box'
            onMouseOver={() => handleHover(7)}
            onMouseOut={() => handleLeave(7)}
            onClick={() => toProducts()}
          >
            <div
              className='icon'
              style={{
                background: `url(${
                  divHoverStatus[7] ? '/minio_ws/catalog/more-hover.png' : '/minio_ws/catalog/more.png'
                })`,
              }}
            ></div>
            <div className='title'>更多产品系列</div>
            <div className='sub-title'>More product lines</div>
          </div>
        </div>
      </div>

      {/* 活动banner */}
      <div className='activity-banner'>
        <img className='activity-banner-bg' src='/api/home_page/pic_load/product/background' alt='' width='100%' />
        <div className='activity-content'>
          <img className='activity-title' src='/api/home_page/pic_load/product/topic' alt='' />
          <div className='detail-button' onClick={goProductDetail}>
            {map.a[la]} <ArrowRightOutlined className='icon' />
          </div>
        </div>
      </div>

      {/* 新闻资讯 */}
      <div className='news-container'>
        <div className='news'>
          <div className='split-title-content'>
            <p className='title'>新闻资讯</p>
            <div className='split-line'>
              <div className='line'></div>
              <div className='logo'>
                <img src={LOGO_IMG} alt='' />
              </div>
              <div className='line'></div>
            </div>
            <p className='sub-title'>News</p>
          </div>

          <div className='news-content'>
            {recommendNewsInfo.map((news: IRecommendNewsInfo) => (
              <div className='news-list' key={news.id} onClick={() => toNewsDetail(news.id)}>
                <div className={`news-type-name ${color[news.type]}`}>【{type[news.type][la]}】</div>
                <div className='news-title'>{news.title}</div>
                <div className='news-ctime'>{news.publishDate}</div>
              </div>
            ))}
          </div>
          <div className='more-button' onClick={toNews}>
            {map.e[la]} <ArrowRightOutlined className='icon' />
          </div>
        </div>
      </div>

      {/* 关于钒泰 */}
      <div className='home-about'>
        <img src={ABOUT_IMG} alt='' width='42%' />
        <div className='about-content'>
          <div className='detail'>
            <div className='detail-title'>{map.b[la]}</div>
            <div className='detail-content'>
              {map.c[la]}
              <br />
              {map.d[la]}
            </div>
            <div className='more-button' onClick={toAbout}>
              {map.e[la]} <ArrowRightOutlined className='icon' />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;
